import { render, staticRenderFns } from "./SchoolCounselingConfigModal.vue?vue&type=template&id=404d4107&scoped=true"
import script from "./SchoolCounselingConfigModal.vue?vue&type=script&lang=js"
export * from "./SchoolCounselingConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d4107",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404d4107')) {
      api.createRecord('404d4107', component.options)
    } else {
      api.reload('404d4107', component.options)
    }
    module.hot.accept("./SchoolCounselingConfigModal.vue?vue&type=template&id=404d4107&scoped=true", function () {
      api.rerender('404d4107', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/TutorStandBook/components/TutorTimeSetting/components/SchoolCounselingConfigModal.vue"
export default component.exports